/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Sticky header on scroll up only
  let lastScroll = 0;
  const header = document.querySelector('[data-header-wrapper]');
  
  if (header && header.hasAttribute('data-header-sticky')) {
    const headerHeight = header.offsetHeight;
    
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;
      
      if (currentScroll <= headerHeight) {
        header.classList.remove('js__header__stuck');
      } else if (currentScroll < lastScroll) {
        header.classList.add('js__header__stuck');
      } else {
        header.classList.remove('js__header__stuck');
      }
      
      lastScroll = currentScroll;
    });
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
